// extracted by mini-css-extract-plugin
export default {"staticWrapper":"static_pages__staticWrapper--VK9Z","aboutContent":"static_pages__aboutContent--Y5lM"};